export default __webpack_public_path__ + "static/headstand-variations-3-0635a72ed27ae93be3874a047156b658.jpg";